import { render, staticRenderFns } from "./MessagesTab.vue?vue&type=template&id=13e356c9"
import script from "./MessagesTab.vue?vue&type=script&lang=js"
export * from "./MessagesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports